import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8cf036ajhp: FaireBrandEntity = {
  token: "b_8cf036ajhp",
  type: "brand",
  name: "Boston International",
  avatarUrl:
    "https://cdn.faire.com/fastly/4f7e5f396bb1ff1978ae2a1b5b878aa2f2f3e22c93053d0a4b6af0f2470243d6.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a1f2d0495e4661bc3744b9ea9b587e73b6def68d0483059a4dd2c4998dfb6788.png",
  logoUrl:
    "https://cdn.faire.com/fastly/4f7e5f396bb1ff1978ae2a1b5b878aa2f2f3e22c93053d0a4b6af0f2470243d6.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a1f2d0495e4661bc3744b9ea9b587e73b6def68d0483059a4dd2c4998dfb6788.png",
  location: "French Lick, IN, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 3052,
  isTopShop: true,
  isInsider: true,
  description:
    "Boston International is a woman-owned, design-driven company that has been a leader in the gift industry since 1986. BI started as an import company, and in 2001 became the exclusive distributor of Ideal Home Range® (IHR) - the highest quality paper linen and tabletop accessory line imported from Germany. \n\nIn 2013, with new owners and a new management team in place, BI launched its' own brand of giftware and increased dynamic partnerships with artists including - The Rosanne Beck Collection, Marimekko, and Anne Taintor - to name a few.\n\nWe are deeply committed to growing the company’s partnerships with vendors and retailers to develop innovative products of superior quality that celebrate the home. We are driven by our excitement for home and entertaining, and love sharing our collections with the world!\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:56.061Z",
    importedBy: "entity-db-cli",
  },
};
